import React from 'react'
import DesignSystemContent from '../../components/templates/designSystem/DesignSystemContent'
import Grid from '../../components/molecules/Grid'
import {
    AccentTextM,
    ArticleH2, BoldTextXS, TextXS,
} from './Fonts'
import DesignSystemItem from '../../components/templates/designSystem/DesignSystemItem'
import styled from 'styled-components'
import {radius} from '../../styles/template'

interface Props {}

const RadiusNormal = styled(DesignSystemItem)`
  border-radius: ${radius.normal};
`;

const RadiusLarge = styled(DesignSystemItem)`
  border-radius: ${radius.large};
`;

const SmallShadow = styled(DesignSystemItem)`
  box-shadow: ${props => props.theme.boxShadow.Small};
`;

const NormalShadow = styled(DesignSystemItem)`
  box-shadow: ${props => props.theme.boxShadow.Normal};
`;

const MiddleShadow = styled(DesignSystemItem)`
  box-shadow: ${props => props.theme.boxShadow.Middle};
`;

const LongShadow = styled(DesignSystemItem)`
  box-shadow: ${props => props.theme.boxShadow.Long};
`;

const ExtremeShadow = styled(DesignSystemItem)`
  box-shadow: ${props => props.theme.boxShadow.Extreme};
`;

const ObjectStyles: React.FC<Props> = () => {
    return (
        <DesignSystemContent title='Object styles'>
            <Grid col='1' gap='2'>
                <ArticleH2>Border radius</ArticleH2>
                <code> {"border-radius: ${radius.normal};"}</code>
                <Grid col='1' colDesktop='5' gap='4'>
                    <RadiusNormal>
                        <BoldTextXS><code>{'radius.normal'}</code></BoldTextXS>
                        <TextXS>Used for all types of elements</TextXS>
                    </RadiusNormal>
                    <RadiusLarge>
                        <BoldTextXS><code>{'radius.large'}</code></BoldTextXS>
                        <TextXS>Used for popup</TextXS>
                    </RadiusLarge>
                </Grid>
            </Grid>
            <Grid col='1' gap='2'>
                <ArticleH2>Shadows</ArticleH2>
                <code> {"box-shadow: ${props => props.theme.boxShadow.Small};"}</code>
                <Grid col='1' colDesktop='5' gap='4'>
                    <SmallShadow>
                        <BoldTextXS><code>{'Small'}</code></BoldTextXS>
                        <TextXS>Used for top, items</TextXS>
                    </SmallShadow>
                    <NormalShadow>
                        <BoldTextXS><code>{'Normal'}</code></BoldTextXS>
                        <TextXS>Used for form items that you can select (on the white background)</TextXS>
                    </NormalShadow>
                    <MiddleShadow>
                        <BoldTextXS><code>{'Middle'}</code></BoldTextXS>
                        <TextXS>Used for  hover effect with bottom shift</TextXS>
                    </MiddleShadow>
                    <LongShadow>
                        <BoldTextXS><code>{'Long'}</code></BoldTextXS>
                        <TextXS>Used for some items</TextXS>
                    </LongShadow>
                    <ExtremeShadow>
                        <BoldTextXS><code>{'Extreme'}</code></BoldTextXS>
                        <TextXS>Used for modals</TextXS>
                    </ExtremeShadow>
                </Grid>
            </Grid>
        </DesignSystemContent>
    )
}

export default ObjectStyles